import React, {  Component } from 'react';
import {  dbQuery } from "../../../../api"
import { Folder} from 'react-feather';
import moment from 'moment';

import '../../../../index.scss';

class RoundAvailabilityCube extends Component {
    constructor(props) {
        super(props);
        this.qType = this.props.qType ? this.props.qType : 'number'
        this.state = {
            loading: true,
            data: 0,
        }
    }

    doQuery = () => {
        if (this.props.query) {       
            dbQuery(this.props.query).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({ data: d2, loading: false});                    
                }
            });
        } else this.setState({ loading: false});                    
    };

    doLocalQuery = () => {

        return 0;     
                
    }


    componentDidMount() {
        this.doQuery();
    }

    render(){
        if (this.state.loading) { return null; }
        const {round} = this.props;
        var start = moment(round.startDate).format('M/D h:mm A')
        var stop = moment(round.stopDate).format('M/D h:mm A')
        var newBG = "bg-primary"

        return (
            <div className="card o-hidden widget-cards">
                <div className={`${newBG} card-body`}>
                    <div className="media static-top-widget row">
                        <div className="icons-widgets col-3">                            
                            <div className="align-self-center text-center"><Folder className="font-primary" /></div>
                        </div>
                        <div className="media-body col-9">
                            <span className="m-0" >
                                <h3 style={{marginBottom: "0px"}}>{round.title}&nbsp;</h3>
                            </span>
                            <h3 style={{lineHeight: "1em", fontSize: "15px"}} className="mb-0">
                                <small>{`${start} - ${stop}`}</small>
                            </h3> 
                           
                        </div>    
                    </div>
                </div>
            </div>    
        )
    }
}

export default RoundAvailabilityCube;